<template>
  <v-container
    class="justify-center"
    container--fluid
    fill-height
    style="background: #e6e6fc;"
  >
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="6" lg="5" xl="5">
        <v-stepper
          v-model="st"
          class="ra-2"
          style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
                    box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.096) ;
              "
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat text class="pa-5 elevation-0">
                <v-card-title primary-title class="justify-space-around">
                  <span
                    class="title primary--text d-block text-center font-weight-bold"
                    >Konfirmasi Pesanan</span
                  >
                </v-card-title>
                <v-card-text>
                  <v-row column wrap>
                    <v-col cols="12" class="text-center">
                      <p class="justify-space-around black--text caption mb-0">
                        Silakan periksa kembali data pesanan Anda berikut ini.
                        Pastikan
                        <b>surel</b> yang akan Anda
                        <b>dapat kami hubungi.</b>
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                Surel
                              </th>
                              <th class="text-left">
                                Nama Instansi
                              </th>
                              <th class="text-left">
                                Jenis Pesanan
                              </th>
                              <th class="text-left">
                                Periode
                              </th>
                              <th class="text-left">
                                Total Kuota
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in order" :key="item.name">
                              <td>{{ item.email }}</td>
                              <td>{{ item.nama }}</td>
                              <td>
                                {{
                                  item.k_jenis_pesanan == 1
                                    ? "Berlangganan Baru"
                                    : item.k_jenis_pesanan == 2
                                    ? "Perpanjangan"
                                    : "Tambah Kuota"
                                }}
                              </td>
                              <td>{{ item.nama }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      st: 1,
      dialog: false,
      loading: false,
      kode: null,
      jenisOrder: {
        1: "Berlangganan",
        2: "Perpanjangan",
        3: "Penambahan Kuota"
      },
      konfirmasi: "",
      is_konfirmasi: false,
      order: null
    };
  },
  activated() {
    this.is_konfirmasi = false;
  },
  methods: {
    onOrder() {
      this.loading = true;
      this.order.organisasi_id = this.current_organisasi.organisasi_id;
      this.order.nama = this.current_organisasi.nama;
      this.order.email = this.current_user.email;
      this.order.kuota = Number(this.order.kuota);
    },
    onBatal() {
      this.$router.push({
        name: "billing",
        params: {
          organisasi_id: this.organisasi_id
        }
      });
    },
    onKonfirm(tipe) {
      this.konfirmasi = tipe;
      this.dialog = true;
    },
    onSubmit() {
      if (this.konfirmasi === "batal") this.onBatal();
      else this.onOrder();
    }
  }
};
</script>
<style scoped lang="css">
@media only screen and (min-width: 960px) {
  .container {
    max-width: 1020px !important;
  }
}
</style>
